export const LOAD_MORE = "loadMore";
export const SUBSCRIBE = "subscribe";
export const UNSUBSCRIBE = "unsubscribe";
export const MARK_AS_READ = "markAsRead";
